"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PromptChip = exports.PROMPT_CHIP_TYPE = void 0;
var React = _interopRequireWildcard(require("react"));
var _typography = require("../../types/typography");
var _classify = require("../../utils/classify");
var _qa = require("../../utils/qa");
var _ConditionalWrapper = require("../ConditionalWrapper");
var _Icon = require("../Icon");
var _Tooltip = require("../Tooltip");
var _PromptChipModule = _interopRequireDefault(require("./PromptChip.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const PROMPT_CHIP_TYPE = exports.PROMPT_CHIP_TYPE = Object.freeze({
  primary: 'primary',
  secondary: 'secondary'
});
const PromptChip = exports.PromptChip = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
    type = PROMPT_CHIP_TYPE.primary,
    onClick,
    iconType = _Icon.ICON_TYPE.solid,
    iconName = 'lightbulb',
    children,
    iconColor,
    rightSlot,
    classNames,
    dismissable,
    showInfoIcon,
    infoIconTooltip,
    testId
  } = props;
  // Type narrowing to safely access properties only when they exist
  const onDismiss = dismissable === true && 'onDismiss' in props ? props.onDismiss : undefined;
  const selfDismiss = dismissable === true && 'selfDismiss' in props ? props.selfDismiss : false;
  const [dismissed, setDismissed] = React.useState(false);
  const closeClickHandler = e => {
    e.stopPropagation();
    onDismiss?.(e);
    if (selfDismiss) {
      setDismissed(true);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: !dismissed && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      ref: ref,
      "data-testid": (0, _qa.generateTestId)({
        base: testId,
        slot: 'root'
      }),
      className: (0, _classify.classify)(_PromptChipModule.default.promptChipWrapper, {
        [_PromptChipModule.default.primary]: type === PROMPT_CHIP_TYPE.primary,
        [_PromptChipModule.default.secondary]: type === PROMPT_CHIP_TYPE.secondary
      }, classNames?.wrapper),
      onClick: event => {
        onClick?.(event);
      },
      tabIndex: onClick ? 0 : undefined,
      role: "button",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classify.classify)(_PromptChipModule.default.promptChipContainer, {
          [_PromptChipModule.default.promptChipContainerHover]: !!onClick
        }, classNames?.container),
        "data-testid": (0, _qa.generateTestId)({
          base: testId,
          slot: 'content'
        }),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _classify.classify)(_PromptChipModule.default.leftSection, classNames?.leftSlot),
          "data-testid": (0, _qa.generateTestId)({
            base: testId,
            slot: 'left'
          }),
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
            size: _Icon.ICON_SIZE.small,
            name: iconName,
            type: iconType,
            color: iconColor,
            className: (0, _classify.classify)({
              [_PromptChipModule.default.chipIconDefaultColor]: !iconColor
            }, classNames?.icon),
            testId: (0, _qa.generateTestId)({
              base: testId,
              slot: 'icon'
            })
          }), !!children && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _classify.classify)(_PromptChipModule.default.childrenWrapper, classNames?.children),
            "data-testid": (0, _qa.generateTestId)({
              base: testId,
              slot: 'text'
            }),
            children: children
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: (0, _classify.classify)(_PromptChipModule.default.rightSection, classNames?.rightSlot),
          "data-testid": (0, _qa.generateTestId)({
            base: testId,
            slot: 'right'
          }),
          children: [rightSlot ? rightSlot : null, !!showInfoIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ConditionalWrapper.ConditionalWrapper, {
            condition: infoIconTooltip && typeof infoIconTooltip === 'object' && Object.keys(infoIconTooltip).length > 0,
            wrapper: children => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
              ...infoIconTooltip,
              testId: (0, _qa.generateTestId)({
                base: testId,
                slot: 'tooltip'
              }),
              children: children
            }),
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
              size: _Icon.ICON_SIZE.small,
              name: "info-circle",
              color: _typography.TEXT_COLORS.primary,
              className: classNames?.icon,
              testId: (0, _qa.generateTestId)({
                base: testId,
                slot: 'info-icon'
              })
            })
          }), !!dismissable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.CloseIcon, {
            size: _Icon.ICON_SIZE.small,
            onClick: closeClickHandler,
            ariaLabel: "Dismiss",
            className: _PromptChipModule.default.dismissIcon,
            testId: (0, _qa.generateTestId)({
              base: testId,
              slot: 'dismiss'
            })
          })]
        })]
      })
    })
  });
});